module.exports = __webpack_public_path__ + "static/img/bg-tr.b1e967e1.png";